module.exports = __webpack_public_path__ + "img/user_head_female.b90c3576.png";